// library imports
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// User Component imports
import * as Constants from "_core/configs/Constants";
import * as SceneConfig from "_core/configs/SceneConfig";
import { canUseOperatorTool } from "_core/utils/common";
import { setMenuState, setInitializeState } from "_core/slices/scene/SceneSlice";

/**
 * 運営ツール画面の共通処理
 * メニュー表示の設定と、権限の無いユーザーがURLを直接指定した場合の403遷移を行う（画面側はUX目的。実際の制御はサーバー）。
 * 初期化が終わったら onReady を1回呼ぶ。isAllowed(auth, tUser) で利用条件を差し替えられる（既定は運営ツールの権限）。
 * @returns {{canUse: boolean}}
 */
export const useOperatorPage = (onReady, isAllowed = canUseOperatorTool) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { initializeState } = useSelector((store) => store.scene);
    const { tAccount, tUser } = useSelector((store) => store.transaction);
    const canUse = isAllowed(tAccount?.auth, tUser);

    useEffect(() => {
        dispatch(setMenuState({ isHeader: false, isMenu: true, isFooter: false, isFullScreen: false }));
    }, [dispatch]);

    useEffect(() => {
        if (initializeState < Constants.INITIALIZE_STATE.allComplete) return;
        if (!canUse) navigate(SceneConfig.PAGES.ERROR_403, { replace: true });
    }, [initializeState, canUse]);

    useEffect(() => {
        if (initializeState !== Constants.INITIALIZE_STATE.allComplete || !canUse) return;
        dispatch(setInitializeState(Constants.INITIALIZE_STATE.pageDataFetching));
        Promise.resolve(onReady()).finally(() => {
            dispatch(setInitializeState(Constants.INITIALIZE_STATE.pageDataFetchComplete));
        });
    }, [initializeState]);

    return { canUse };
};

export default useOperatorPage;
